/**
 * Lightweight client-side email check shared by auth forms and Webflow embeds.
 * Matches Zod's `.email()` shape closely enough that the client rejects what the
 * server would 400 (e.g. `sarah.khan@example` with no domain TLD).
 *
 * Kept dependency-free so standalone embed bundles can import it without pulling
 * the API client (unlike `auth/registerErrors.ts`).
 */
export function isValidEmail(value: string): boolean {
  const trimmed = value.trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
}
